import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";

import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import notificationState from "../../states/notificationState";

import DeleteRecordButton from "../input/DeleteRecordButton";
import DataAllSaveToExcelButton from "../input/DataAllSaveToExcelButton";
import CustomRecordButton from './../input/CustomRecordButton';
import isChecked from './../../lib/utils/isChecked';

function CardClass ( props ) {
     const id = "CardClass";

    const [schema, setSchema] = useState();
    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [selectGrid, setSelectGrid] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;
        async function schemaSetting() {
            let schema = await getSchema("CardClass");
            if(mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();
        return (() => {
            mounted = false;
        });
    }, []);

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setSelectGrid(grid.selectedItems[0]);
                    } else {
                        setSelectGrid(undefined);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectGrid(grid.selectedItems[0]);
                    } else {
                        setSelectGrid(undefined);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };
    
    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const modifyFormDataCallback = (newFormData, name, value) => {
        switch(name){
            case"stampingRainbow":
                newFormData.stampingRainbow = value ? 24001 : null;
                break;
            case"stampingHologram":
                newFormData.stampingHologram = value ? 24002 : null;
                break;
            case"stampingSignaturePlate":
                newFormData.stampingSignaturePlate = value ? 24003 : null;
                break;

            default:
                break;
        }
    }

    const modifyFormDataCallbackOK = (newFormData) => {
        newFormData.stampingRainbow = newFormData?.stampingRainbow ? 24001 : null;
        newFormData.stampingHologram = newFormData?.stampingHologram ? 24002 : null;
        newFormData.stampingSignaturePlate = newFormData?.stampingSignaturePlate ? 24003 : null;
    }

    const modifyUrlCallback = (url) => {
        return url + "/" + selectGrid?.classCode
    }
    const initDataCallBack = (initData) => {

        initData.isUse = isChecked(initData.isUse) ? "Y" : "N";
    }

    return <BasicCrudScreenType 
        id="CardClass" 
        table="CardClass" 
        view="VwCardClass"
        onApiInitialized={onApiInitialized}
        onInitialized={onInitialized}
        noCreate
        noEdit
        noDelete
        noExcel
        onAppendButtonInFrontOfSearch={() => (
            <>
                <BasicCrudScreenActionItemLayout>
                    <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                        <CustomRecordButton
                            id={id}
                            refresh={api}
                            schema={schema}
                            onSuccess={onSuccess}
                            mode="create"
                            title="create"
                            buttonFullName="buttonName.create"
                            modifyFormDataCallbackOK={modifyFormDataCallbackOK}
                        />
                    </AccessControl>

                    <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch?"PATCH":"PUT")}>
                        <CustomRecordButton 
                            id={id}
                            grid={grid}
                            refresh={api}
                            schema={schema}
                            isFormData={true}
                            disabled={selectGrid ? false : true}
                            mode="edit"
                            method="put"
                            title="update"
                            buttonFullName="buttonName.update"
                            onSuccess={notifySuccess}
                            initDataCallBack={initDataCallBack}
                            modifyUrlCallback={modifyUrlCallback}
                            modifyFormDataCallback={modifyFormDataCallback}
                            modifyFormDataCallbackOK={modifyFormDataCallbackOK}
                        />
                    </AccessControl>

                    <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                        <DeleteRecordButton
                            id={id}
                            schema={schema}
                            grid={grid}
                            refresh={api}
                            color="secondary"
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                            disabled={selectGrid ? false : true}
                        />
                    </AccessControl>

                    <AccessControl accessTarget={schema && schema.name} accessMethod="SAVETOEXCEL" >
                        <DataAllSaveToExcelButton
                            id={id}
                            grid={grid}
                            view="VwCardClass"
                            excelFileName="카드 구분 관리"
                            color="primary"
                            disabled={selectGrid ? false : true}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            </>
        )} 
    />

}

export default CardClass;

